import OneSignal from 'react-onesignal';

export default async function runOneSignal() {
    await OneSignal.init({ appId: window.runtime_configs.onesignal_app_id, allowLocalhostAsSecureOrigin: true});
    OneSignal.showSlidedownPrompt();
}
